<mat-card matRipple [routerLink]="'/marketing/article/' + data.id">
  <app-image [fileid]="data.cover" width="168px" height="168px"></app-image>

  <div class="right">
    <h1>{{ data.title }}</h1>
    <div class="tags">
      <app-platform-tag *ngFor="let t of data.tags" [text]="t">
      </app-platform-tag>
    </div>
    <div class="desc">{{ data.brief }}</div>
  </div>
</mat-card>
